import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export class CorrelatedGamesReader {
    constructor(private readonly services: IServiceFactoryExtended) {

    }

    private readonly _correlatedGamesCache: Record<number, number[]> = [];

    async getCorrelatedGame(gameType: number, numberOfGames: number): Promise<number[]> {
        try{
            let correlatedGames = await this._readCorrelatedGames(gameType);
            const recentlyPlayedGames = await this.services.games.getRecentlyPlayedGamesAsync();
            //filter out recently played games and keep only the games that are in the layout
            correlatedGames = correlatedGames.filter(gt => !recentlyPlayedGames.includes(gt)
                                                                    && Boolean(this.services.games.gamesMap[gt]));

            return correlatedGames.slice(0, numberOfGames);
        } catch (err) {
            this.services.logger.error(`Failed to read correlated games for game type ${gameType}`, err);
            return [];
        }


    }

    private async _readCorrelatedGames(gameType: number): Promise<number[]> {
        if(this._correlatedGamesCache[gameType]) {
            return this._correlatedGamesCache[gameType];
        }

        const response = await this.services.api.gamesCorrelationController.getCorrelatedGamesV2({
            gameType: gameType
        });

        this._correlatedGamesCache[gameType] = response.correlatedGameTypes;
        return response.correlatedGameTypes;
    }
}